"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedisProviderType = void 0;
var RedisProviderType;
(function (RedisProviderType) {
    RedisProviderType["THROTTLE"] = "THROTTLE";
})(RedisProviderType || (exports.RedisProviderType = RedisProviderType = {}));
//# sourceMappingURL=provider.js.map